import { Graphics, Text } from "pixi.js";
import { GameConfigs } from "../../lib/globals/GameConfigs";
import { EVENTS } from "../../lib/constants";
import QuestData from "./helper/getQuestData";
import HELPERS from "../../lib/globals/helpers/Helpers";

class QuestDailyController {
  constructor(vc, conf) {
    this.config = conf;
    this.completed = false;
    this.positions = {
      width: window.isMobile || window.isTablet ? 340 : 375,
      x: window.isMobile || window.isTablet ? 140 : 260,
      y: window.isMobile || window.isTablet ? 74 : 190,
    };
    if (vc.getChildByName(this.config.item, true)) {
      this.vc = vc.getChildByName(this.config.item, true);
      this.quest_data = QuestData.processQuest(GameConfigs.quest);
      this.vc.itemdesc.text = GameConfigs.time_left;
      this.total_progress = this.quest_data.total_progress;
      this.total_progress_amount = this.quest_data.items.length;
      window.addEventListener(EVENTS.SERVER_MSG, this, false);
      window.addEventListener(EVENTS.MODAL, this, false);
      window.addEventListener(EVENTS.QUEST_UPDATE, this, false);
      this.init();
    } else {
      throw new Error(
        "QuestDailyController failed init " + JSON.stringify(this.config)
      );
    }
  }

  handleEvent(evt) {
    switch (evt.type) {
      case EVENTS.SERVER_MSG:
        if (evt.detail.service === "quest") {
          this.total_progress = this.handleProgress(evt.detail.data);
          this.quest_data = QuestData.processQuest(evt.detail.data);
          this.vc.itemprogresstext.tint =
            this.total_progress_amount / this.total_progress < 2
              ? "#230E35"
              : "#DEE0EF";
          this.checkComplete(this.total_progress, this.total_progress_amount);
          if (evt.detail.data.status === "completed") {
            if (!GameConfigs.quest_claim.claimed) {
              HELPERS.dispatchCustomEvent(EVENTS.QUEST_CLAIM, {
                quest_claim: {
                  ...GameConfigs.quest_claim,
                  claim: true,
                  actived: false,
                  activated_item: 0,
                },
              });
            }
            window.removeEventListener(EVENTS.SERVER_MSG, this, false);
          }
        }
        break;
      case EVENTS.MODAL:
        if (evt.detail.modal !== "quest") {
          window.removeEventListener(EVENTS.SERVER_MSG, this, false);
          window.removeEventListener(EVENTS.MODAL, this, false);
        }
        break;
      case EVENTS.QUEST_UPDATE:
        this.vc.itemdesc.text = evt.detail.formated;
        break;
      default:
        break;
    }
  }
  init() {
    // let radius = 0.3;
    this.text_style = {
      fontSize: 14,
      fontFamily: "Poppins SemiBold",
      fill:
        this.total_progress_amount / this.total_progress < 2
          ? "#230E35"
          : "#DEE0EF",
    };
    //Add Progress Bar
    this.vc.itemprogress = new Graphics();
    this.vc.itemprogress.clear();
    this.vc.itemprogress.beginFill(0x0d3548);
    this.vc.itemprogress.drawRoundedRect(
      this.positions.x,
      this.positions.y,
      this.positions.width,
      16,
      12
    );

    this.vc.addChild(this.vc.itemprogress);
    //Add Progress Result bar
    this.vc.itemprogressresult = new Graphics();
    this.vc.itemprogress.addChild(this.vc.itemprogressresult);
    //Add Progress Text
    this.vc.itemprogresstext = new Text("", this.text_style);
    this.vc.itemprogresstext.anchor.x = 0.5;
    this.vc.itemprogresstext.position.x =
      this.positions.x + this.vc.itemprogress.getBounds().width / 2;
    this.vc.itemprogresstext.y = this.positions.y;
    this.vc.itemprogress.addChild(this.vc.itemprogresstext);
    this.checkComplete(this.total_progress, this.total_progress_amount);
  }

  drawRectangle(vc, x, y, w, h, r, progress) {
    vc.clear();
    vc.beginFill(progress >= this.total_progress_amount ? 0xa2af50 : 0xe5a7dd);
    vc.drawRoundedRect(x, y, w, h, r);
  }

  checkComplete(current, total) {
    if (current >= total) {
      this.completed = true;
      this.vc.itemprogresstext.text = "COMPLETED";
      this.drawRectangle(
        this.vc.itemprogressresult,
        this.positions.x,
        this.positions.y,
        this.positions.width,
        16,
        0.3 * this.positions.width,
        current
      );
    } else {
      this.vc.itemprogresstext.text = current + "/" + total;
      this.drawRectangle(
        this.vc.itemprogressresult,
        this.positions.x,
        this.positions.y,
        (this.positions.width / total) * current,
        16,
        ((0.3 * this.positions.width) / total) * current,
        current
      );
    }
  }

  handleProgress(data) {
    let progress = 0;
    for (let i = 0; i < this.quest_data.items.length; i++) {
      if (data.progresses[i] >= data.items[i].count) {
        progress++;
      }
    }
    return progress;
  }
}

export default QuestDailyController;
